import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { speedDialFabAnimations } from './speed-dial-fab.animations';
import { TwilioService } from '../../services/twilio.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { CreateActionFormComponent } from '../create-action-form/create-action-form.component';
import { MatDialog } from '@angular/material/dialog';
import {
    ILeadFormDlgResult,
    LeadFormComponent,
    LeadFormDlgDataParams,
} from 'src/app/leads/lead-form/lead-form.component';
import { ToastrService } from 'ngx-toastr';

export type MatFabMenuDirection = 'top' | 'bottom' | 'left' | 'right';

interface IFabButton {
    id: string;
    icon: string;
    url?: string[];
    title: string;
    queryParams?: { orderType: 'quote' | 'order' };
    onClick?(): void;
}
@Component({
    selector: 'app-speed-dial-fab',
    templateUrl: './speed-dial-fab.component.html',
    styleUrls: ['./speed-dial-fab.component.scss'],
    animations: speedDialFabAnimations,
})
export class SpeedDialFabComponent implements OnInit {
    @Input() direction: MatFabMenuDirection = 'bottom';
    @ViewChild(CreateActionFormComponent) createActionFormComponent: CreateActionFormComponent;

    fabButtons: IFabButton[] = [
        {
            id: 'quote',
            icon: 'fab_add_quote.svg',
            url: ['order', 'create', 'customer-select'],
            title: 'New quote',
            queryParams: { orderType: 'quote' },
        },
        {
            id: 'order',
            icon: 'fab_add_order.svg',
            url: ['order', 'create', 'customer-select'],
            title: 'New order',
            queryParams: { orderType: 'order' },
        },
    ];
    buttons = [];
    fabTogglerState = 'inactive';

    constructor(
        private twilioService: TwilioService,
        private dialog: MatDialog,
        private toastrService: ToastrService
    ) {}

    showItems() {
        this.fabTogglerState = 'active';
        this.buttons = this.fabButtons;
    }

    hideItems() {
        this.fabTogglerState = 'inactive';
        this.buttons = [];
    }

    onToggleFab(cb?) {
        if (cb) {
            cb.call();
        }
        this.buttons.length ? this.hideItems() : this.showItems();
    }

    ngOnInit(): void {
        this.fabButtons.unshift({
            id: 'action',
            icon: 'fab_new_action.svg',
            title: 'New action',
            onClick: () => {
                this.showCreateActionForm();
            },
        });
        this.fabButtons.unshift({
            id: 'prospect',
            icon: 'fab_contact.svg',
            title: 'New prospect',
            onClick: () => {
                this.showCreateLeadForm();
            },
        });
    }

    private showCreateActionForm() {
        this.dialog.open(CreateActionFormComponent, {
            panelClass: 'create-action-form',
            position: { top: '80px' },
        });
    }

    private showCreateLeadForm() {
        let dialogRef = this.dialog.open(LeadFormComponent, {
            ...LeadFormDlgDataParams,
        });
        const instance = dialogRef.componentInstance;
        instance.withAction = true;
        dialogRef.afterClosed().subscribe((data: ILeadFormDlgResult) => {
            if (data?.status === true) {
                const lead = data.lead;
                this.toastrService.success(`New lead ${lead.contact.firstname} ${lead.contact.surname} created`);
            }
        });
    }
}
